import React from "react";

export default function PrivacyPolicy() {
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "50px auto",
        padding: "20px",
        lineHeight: "1.8",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <h1>Privacy Policy for منصة تفوق (Tafawak)</h1>

      <p><strong>Last Updated:</strong> October 23, 2026</p>

      <p>
        This Privacy Policy applies specifically to the <strong>منصة تفوق (Tafawak)</strong>
        mobile application and its associated website, operated by
        <strong>OPPAD NASSER</strong>.
      </p>

      <p>
        <strong>App Name:</strong> منصة تفوق (Tafawak)<br />
        <strong>Developer Name:</strong> OPPAD NASSER<br />
        <strong>Package Name:</strong> com.elmanassa.mobile_app<br />
        <strong>Official Website:</strong> https://elmanassa.cloud<br />
        <strong>Contact Email:</strong> oppadnasser@gmail.com
      </p>

      <p>
        This Privacy Policy explains how OPPAD NASSER collects, uses, stores,
        and shares information when users access the Tafawak mobile application
        and its associated educational services.
      </p>

      <h2>1. Information We Collect</h2>

      <h3>Account Information</h3>
      <ul>
        <li>Name</li>
        <li>Email address</li>
        <li>Password (stored securely in encrypted form)</li>
      </ul>

      <h3>Educational Information</h3>
      <ul>
        <li>Courses and lessons you enroll in</li>
        <li>Teacher relationships</li>
        <li>Lesson progress</li>
      </ul>

      <h3>QR Code Data</h3>
      <p>
        The application uses your device camera only to scan QR codes for lesson
        registration and verification. Images from the camera are not stored.
      </p>

      <h3>Device Information</h3>
      <ul>
        <li>Device model</li>
        <li>Application version</li>
        <li>Firebase device token for notifications</li>
      </ul>

      <h2>2. How We Use Your Information</h2>

      <ul>
        <li>Create and manage your account.</li>
        <li>Authenticate your identity.</li>
        <li>Provide educational services.</li>
        <li>Register lessons through QR codes.</li>
        <li>Send notifications.</li>
        <li>Improve application performance and security.</li>
        <li>Respond to customer support requests.</li>
      </ul>

      <h2>3. Educational Content</h2>

<p>
  Teachers using <strong>Elmanassa</strong> may create and manage educational
  lessons through the platform.
</p>

<ul>
  <li>
    Teachers upload lesson information such as lesson titles, descriptions, and
    other educational details.
  </li>
  <li>
    <strong>Video files are not uploaded to or stored on Elmanassa's
    servers.</strong>
  </li>
  <li>
    Instead, teachers provide <strong>YouTube video links</strong>, and lesson
    videos are streamed directly from YouTube when students watch them.
  </li>
  <li>
    Elmanassa stores only the information required to organize and provide
    access to lessons, including lesson details and the associated YouTube
    video link.
  </li>
  <li>
    YouTube is responsible for hosting and delivering video content in
    accordance with its own Privacy Policy and Terms of Service.
  </li>
</ul>

      <h2>4. Camera Permission</h2>

      <p>
        Camera access is required only for scanning QR codes. The application
        does not record videos or store photos from your camera.
      </p>

      <h2>5. Notifications</h2>

      <p>
        The Tafawak (منصة تفوق) application uses Firebase Cloud Messaging (FCM)
        to send notifications related to lessons, educational announcements,
        and account updates.
      </p>

      <p>
        To deliver notifications, the application may register a Firebase Cloud
        Messaging token associated with the user's device. This token may be sent
        to our backend server and stored in our database to enable notification
        delivery to the appropriate user.
      </p>

      <p>
        When a user logs out or deletes their account, the application may remove
        the associated notification token from our database as part of account
        and device management.
      </p>

      <h2>6. Third-Party Services and Authentication</h2>

      <p>
        The Tafawak (منصة تفوق) application uses third-party services to provide
        authentication, notifications, and core application functionality.
        These services may process certain information as necessary to provide
        their respective features.
      </p>

      <h3>Google Sign-In</h3>

      <p>
        Users may sign in to the application using Google Sign-In. When a user
        chooses this option, the application receives authentication information
        such as the user's name, email address, Google account identifier, and
        authentication token, as applicable.
      </p>

      <p>
        This information is used to authenticate the user, create or access their
        account, and provide access to the educational services. Authentication
        information may be transmitted securely to our backend server to verify
        the user's identity.
      </p>

      <h3>Firebase Cloud Messaging</h3>

      <p>
        Firebase Cloud Messaging is used to deliver push notifications to users.
        The service processes the technical information necessary to support
        notification delivery, subject to Google's applicable privacy terms.
      </p>

      <h3>Device Identifiers</h3>

      <p>
        The application may generate and store a unique device identifier to
        support account management, device association, security, and access
        control for certain purchased educational content. This identifier may
        be transmitted to our backend server and associated with the user's
        account where necessary to provide these features.
      </p>

      <h3>Google Play Services</h3>

      <p>
        The application uses Google Play Services to support compatible Android
        functionality. Google may process technical information in accordance
        with its applicable privacy policies and service terms.
      </p>

      <p>
        We do not use these services to sell users' personal information.
        Information is processed only as necessary to provide the application's
        features, maintain security, and operate the educational platform,
        subject to applicable legal requirements.
      </p>


      <h2>7. Data Security</h2>

      <p>
        We use reasonable administrative and technical measures to protect your
        information. All communication between the application and our servers
        is encrypted using HTTPS.
      </p>

      <h2>8. Data Sharing</h2>

      <p>
        We do not sell or rent your personal information. Information is shared
        only when necessary to operate the service or when required by law.
      </p>

      <h2>9. Children's Privacy</h2>

      <p>
        Our services are intended for students and educational purposes. We do
        not knowingly collect personal information from children in violation of
        applicable laws.
      </p>

      <h2>10. Your Rights</h2>

      <p>You may request to:</p>

      <ul>
        <li>Access your personal information.</li>
        <li>Correct inaccurate information.</li>
        <li>Delete your account where applicable.</li>
      </ul>

      <h2>11. Changes to This Privacy Policy</h2>

      <p>
        We may update this Privacy Policy from time to time. Changes will be
        posted on this page with a revised "Last Updated" date.
      </p>

      <h2>12. Contact Us</h2>

      <p>
        If you have questions about this Privacy Policy, please contact us:
      </p>

      <p>
        <strong>Elmanassa</strong>
        <br />
        Website: https://elmanassa.cloud
        <br />
        Email: oppadnasser@gmail.com
        <br />
        developer: OPPAD NASSER
        <br/>
      </p>

      <p>
        <strong>Package Name : com.elmanassa.mobile_app</strong>
      </p>
    </div>
  );
}